import {
  AcceptOffer,
  AcceptOfferVariables,
} from "_graphql/mutation/__generated__/AcceptOffer";
import { useAppSearch, useCurrentUser } from "_graphql/cache/auth";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { acceptUnderwriterOffer } from "_graphql/place-it/mutations/underwriter.place-it";
import { placeItClient } from "_graphql";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-location";

export default function ApproveContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const currentUser = useCurrentUser();
  const navigate = useNavigate<LocationGenerics>();
  const [execute, { loading }] = useMutation<AcceptOffer, AcceptOfferVariables>(
    acceptUnderwriterOffer,
    {
      client: placeItClient,
    }
  );

  const form = useFormik<any>({
    initialValues: {},
    onSubmit: async (values, helpers) => {
      execute({
        variables: {
          employeeId: currentUser?.employee?.employee_id || "",
          offerId: searchParams?.id || "",
        },
      })
        .then(({ data }) => {
          if (data?.acceptOffer?.status) {
            helpers.resetForm();
            if (data?.acceptOffer?.status === 200) {
              toast.success(
                data?.acceptOffer?.message ||
                  "Underwriter offer accepted successfully"
              );
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    id: undefined,
                    modal: undefined,
                  };
                },
              });
            } else {
              toast.error(
                data?.acceptOffer?.message || "Could not approve underwriter"
              );
            }
          }
        })
        .catch((err) => {
          toast.error("Could not approve underwriter");
        });
    },
    onReset: () => {
      setOpen(false);
      navigate({
        search(prev) {
          return {
            ...prev,
            id: undefined,
            modal: undefined,
          };
        },
      });
    },
  });

  const handleSubmit = () => {
    form.submitForm();
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Accept Offer"
      cancelText="Cancel"
      description="This action would accept the offer"
      placement="top-center"
      variant="success"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Accepting Offer..." : "Accept Offer"}
          </button>
        </>
      )}
    />
  );
}
